import React from "react";
import "../../styles/CaseStudyTwo/CaseStudiesHero2.css";

const CaseStudiesHero2 = () => {
  return (
    <section id="case-studies-hero-two" className="case-studies-hero2">
      <div className="hero-container2">
        {/* Left Content */}
        <div className="hero-left2">
          <h2 className="hero-subtitle2">End-To-End Tracking</h2>
          <h1 className="hero-title2">John Volken Academy Movers</h1>
          <p className="hero-description2">
          John Volken Academy Movers is a top-rated moving company serving Phoenix, AZ and Kent, WA, known for their professional, reliable, and affordable moving services.
           As a 5-star rated mover, they deliver exceptional customer satisfaction while supporting a greater cause helping individuals 
           transform their lives through the John Volken Academy.
          </p>
          <ul className="hero-kpi-list2">
            <li className="kpi-item2">
              <div className="case-study-checkmark-icon2"></div> Cost Per Move: Decreased from $384 to $149
            </li>
            <li className="kpi-item2">
              <div className="case-study-checkmark-icon2"></div> Total Moves Generated: 64
            </li>
            <li className="kpi-item2">
              <div className="case-study-checkmark-icon2"></div> Increased ROAS from 2.5 to 6.4
            </li>
          </ul>
        </div>

        {/* Right Image */}
        <div className="hero-right2">
          <div className="hero-image-container2">
            <img
              src={require("../../assets/john-volken-logo.png")} // Replace with your image path
              alt="Bullfrog Logo"
              className="hero-image2"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesHero2;
